var Feedback = function Feedback() {
  return {
    text: {
      maxWidth: 520
    }
  };
};

export default Feedback;